import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from './services/auth.service';
import { ChildAuthService } from './services/child-auth.service';
import { RouterModule, Router, Event, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AppLayoutComponent } from './components/layout/app-layout.component';
import { PwaPromptComponent } from './shared/components/pwa-prompt/pwa-prompt.component';
import { environment } from '../environments/environment';
import { UpdateService } from './services/update.service';
import { InactivityService } from './services/inactivity.service';
import { VersionService } from './services/version.service';
import { Subscription } from 'rxjs';
import { ScreenSaverService } from './services/screen-saver.service';
import { ScreenSaverComponent } from './shared/components/screen-saver/screen-saver.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterModule, CommonModule, AppLayoutComponent, PwaPromptComponent, ScreenSaverComponent],
  template: `
    <app-layout>
      <router-outlet></router-outlet>
    </app-layout>
    <app-pwa-prompt></app-pwa-prompt>
    <app-screen-saver></app-screen-saver>
  `
})
export class AppComponent implements OnInit, OnDestroy {
  constructor(
    private auth: AuthService, 
    private childAuthService: ChildAuthService,
    private updateService: UpdateService,
    private inactivityService: InactivityService,
    private versionService: VersionService,
    private screenSaverService: ScreenSaverService,
    private router: Router
  ) {
    console.log('App component constructor called');
    
    // Track all router events globally to debug navigation issues
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        console.log(`[Global Router] Navigation started to: ${event.url}`);
      }
      
      if (event instanceof NavigationEnd) {
        console.log(`[Global Router] Navigation ended at: ${event.url}`);
      }
      
      if (event instanceof NavigationCancel) {
        console.log(`[Global Router] Navigation cancelled: ${event.url}`, event.reason);
      }
      
      if (event instanceof NavigationError) {
        console.log(`[Global Router] Navigation error: ${event.url}`, event.error);
      }
    });
  }
  
  private authSubscription: Subscription | null = null;

  title = 'point-manager';

  ngOnInit() {
    console.log('App component initialized');
    // Clear any previous child authentication on app start
    this.childAuthService.switchToParentMode();
    
    // Initialize version checking with rate limiting
    this.versionService.initVersionCheck();
    
    // Start monitoring user activity when a user is logged in
    this.authSubscription = this.auth.currentUser$.subscribe(user => {
      if (user) {
        this.inactivityService.startMonitoring();
        this.screenSaverService.startMonitoring(); // Start screen saver monitoring
      } else {
        this.inactivityService.stopMonitoring();
        this.screenSaverService.stopMonitoring(); // Stop screen saver monitoring
      }
    });
  }
  
  ngOnDestroy() {
    // Clean up subscriptions
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
      this.authSubscription = null;
    }
    
    // Stop monitoring inactivity
    this.inactivityService.stopMonitoring();
    this.screenSaverService.stopMonitoring(); // Stop screen saver monitoring
  }
}